import { render, staticRenderFns } from "./InfoGraphicsCalendar.vue?vue&type=template&id=880f1c6a&scoped=true&"
import script from "./InfoGraphicsCalendar.vue?vue&type=script&lang=js&"
export * from "./InfoGraphicsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./InfoGraphicsCalendar.vue?vue&type=style&index=0&id=880f1c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880f1c6a",
  null
  
)

export default component.exports